/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerUpRightIcon64Regular = forwardRef('ArrowDCornerUpRightIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M38.56 5.672a1.5 1.5 0 1 0-2.12 2.122l14.938 14.938c.085.085.162.175.233.268H20.5a9.5 9.5 0 0 0-9.5 9.5v24a1.5 1.5 0 1 0 3 0v-24a6.5 6.5 0 0 1 6.5-6.5h31.11c-.07.093-.147.183-.232.268L36.439 41.206a1.5 1.5 0 0 0 2.122 2.121L53.499 28.39a5.5 5.5 0 0 0 0-7.778L38.561 5.672Z" })));
});
